import { Routes } from '@angular/router';
import { StaffLayoutComponent } from './staff-layout/staff-layout.component';
import { SignInComponent } from './sign-in/sign-in.component';
import { SelectMealTransportComponent } from './select-meal-transport/select-meal-transport.component';
import { ProgramsComponent } from './programs/programs.component';
import { SeniorCenterToolsComponent } from './programs/senior-center-tools.component';
import { ManageSeniorCenterComponent } from './programs/manage-senior-center.component';
import { ReportsHubComponent } from './programs/reports-hub.component';
import { ActivityManagementComponent } from './activity-management/activity-management.component';
import { ActivityFormComponent } from './activity-management/activity-form.component';
import { MealMenuManagementComponent } from './meal-menu-management/meal-menu-management.component';
import { MealReportManagementComponent } from './meal-report-management/meal-report-management.component';
import { ActivityReportManagementComponent } from './activity-report-management/activity-report-management.component';
import { MealSummaryReportComponent } from './meal-summary-report/meal-summary-report.component';
import { TransportSummaryReportComponent } from './transport-summary-report/transport-summary-report.component';
import { CardCheckinComponent } from './card-checkin/card-checkin.component';
import { DateSelectionComponent } from './date-selection/date-selection.component';
import { SuccessMealTransportComponent } from './success-meal-transport/success-meal-transport.component';
import { MealPreferanceComponent } from './meal-preferance/meal-preferance.component';
import { ApplyFutureDatesComponent } from './apply-future-dates/apply-future-dates.component';
import { ScheduledConfirmedComponent } from './scheduled-confirmed/scheduled-confirmed.component';
import { ActivityScreenComponent } from './activity-screen/activity-screen.component';
import { UpcomingEventsComponent } from './upcoming-events/upcoming-events.component';
import { EventDetailsComponent } from './event-details/event-details.component';
import { SuccessComponent } from './success/success.component';
import { CheckInComponent } from './check-in/check-in.component';
import { StaffDeliveryLayoutComponent } from './staff-delivery-layout/staff-delivery-layout.component';
import { StaffDeliveryHomeComponent } from './staff-delivery-home/staff-delivery-home.component';
import { ErrorFallbackComponent } from './error-fallback/error-fallback.component';
import { RegisterComponent } from './register/register.component';
import { SeniorCenterApplicationsComponent } from './senior-center-applications/senior-center-applications.component';
import { SeniorCenterApplicationDetailComponent } from './senior-center-applications/senior-center-application-detail.component';
import { StaffManagementComponent } from './staff-management/staff-management.component';
import { StaffFormComponent } from './staff-management/staff-form.component';
import { LocationManagementComponent } from './location-management/location-management.component';
import { LocationFormComponent } from './location-management/location-form.component';
import { permissionGuard } from './core/guards/permission.guard';
import { StaffPermission } from './core/constants/staff-roles';

export const routes: Routes = [
{path: "staff-layout",
component:StaffLayoutComponent,
data:{animation:'StaffLayout'},
children:[
]
},
{path: "",
component:SignInComponent,
data:{animation:'SignIn'},
children:[
]
},
{path: "select-meal-transport",
component:SelectMealTransportComponent,
data:{animation:'SelectMealTransport'},
children:[
]
},
{path: "programs",
component:ProgramsComponent,
data:{animation:'Programs'},
children:[
]
},
{
path: "programs/senior-center",
component: SeniorCenterToolsComponent,
data: { animation: 'SeniorCenterTools' },
children: []
},
{
path: "manage-services/senior-center",
component: ManageSeniorCenterComponent,
data: { animation: 'ManageSeniorCenter' },
children: []
},
{
path: "manage-services/senior-center/activity",
component: ActivityManagementComponent,
data: { animation: 'ActivityManagement' },
children: []
},
{
path: "manage-services/senior-center/activity/create",
component: ActivityFormComponent,
data: { animation: 'ActivityFormCreate' },
children: []
},
{
path: "manage-services/senior-center/activity/edit/:activityId",
component: ActivityFormComponent,
data: { animation: 'ActivityFormEdit' },
children: []
},
{
path: "manage-services/senior-center/meal-menu",
component: MealMenuManagementComponent,
data: { animation: 'MealMenuManagement' },
children: []
},
{
path: "manage-services/senior-center/reports",
component: ReportsHubComponent,
data: { animation: 'ReportsHub' },
children: []
},
{
path: "manage-services/senior-center/reports/activity",
component: ActivityReportManagementComponent,
data: { animation: 'ActivityReportManagement' },
children: []
},
{
path: "manage-services/senior-center/reports/meal-summary",
component: MealSummaryReportComponent,
data: { animation: 'MealSummaryReport' },
children: []
},
{
path: "manage-services/senior-center/reports/meal-order",
component: MealReportManagementComponent,
data: { animation: 'MealOrderReport', mealGridMode: 'ordered' },
children: []
},
{
path: "manage-services/senior-center/reports/meal-delivered",
redirectTo: "manage-services/senior-center/reports/meal-order",
pathMatch: "full"
},
{
path: "manage-services/senior-center/reports/transport",
component: TransportSummaryReportComponent,
data: { animation: 'TransportReport', transportMode: 'booked' },
children: []
},
{
path: "manage-services/senior-center/reports/transport-booked",
redirectTo: "manage-services/senior-center/reports/transport",
pathMatch: "full"
},
{
path: "manage-services/senior-center/reports/transport-summary",
redirectTo: "manage-services/senior-center/reports/transport",
pathMatch: "full"
},
{
path: "manage-services/senior-center/reports/transport-delivered",
redirectTo: "manage-services/senior-center/reports/transport",
pathMatch: "full"
},
{
path: "manage-services/senior-center/meal-report",
redirectTo: "manage-services/senior-center/reports/meal-order",
pathMatch: "full"
},
{path: "check-in",
component:CheckInComponent,
data:{animation:'CheckIn'},
children:[
]
},
{path: "staff-delivery-layout",
component:StaffDeliveryLayoutComponent,
data:{animation:'StaffDeliveryLayout'},
children:[
  {
    path: "",
    component: StaffDeliveryHomeComponent,
    data: { animation: 'StaffDeliveryHome' }
  },
  {
    path: "check-in",
    component: CheckInComponent,
    data: { animation: 'CheckIn', deliveryType: 'meal' }
  },
  {
    path: "meal",
    component: CheckInComponent,
    data: { animation: 'CheckInMeal', deliveryType: 'meal' }
  },
  {
    path: "transport",
    component: CheckInComponent,
    data: { animation: 'CheckInTransport', deliveryType: 'transport' }
  },
  {
    path: "activity",
    component: CheckInComponent,
    data: { animation: 'CheckInActivity', deliveryType: 'activity' }
  },
  {
    path: "activity/:activityId",
    component: CheckInComponent,
    data: { animation: 'CheckInActivity', deliveryType: 'activity' }
  }
]
},
{
path: "card-checkin",
component:CardCheckinComponent,
data:{animation:'CardCheckIn'},
children:[
]
},
{
path: "card-checkin/:programId",
component:CardCheckinComponent,
children:[
]
},
{
path: "register",
component: RegisterComponent,
canActivate: [permissionGuard(StaffPermission.CreateApplicationOnBehalf)],
children: []
},
{
  path: "senior-center-applications",
  component: SeniorCenterApplicationsComponent,
  canActivate: [permissionGuard(StaffPermission.ReviewApplications)],
  data: { animation: "SeniorCenterApplications" },
  children: []
},
{
  path: "senior-center-applications/:applicationId",
  component: SeniorCenterApplicationDetailComponent,
  canActivate: [permissionGuard(StaffPermission.ReviewApplications)],
  data: { animation: "SeniorCenterApplicationDetail" },
  children: []
},
{
  path: "staff-management",
  component: StaffManagementComponent,
  canActivate: [permissionGuard(StaffPermission.ManageStaff)],
  data: { animation: "StaffManagement" },
  children: []
},
{
  path: "staff-management/create",
  component: StaffFormComponent,
  canActivate: [permissionGuard(StaffPermission.ManageStaff)],
  data: { animation: "StaffFormCreate" },
  children: []
},
{
  path: "staff-management/:staffId/edit",
  component: StaffFormComponent,
  canActivate: [permissionGuard(StaffPermission.ManageStaff)],
  data: { animation: "StaffFormEdit" },
  children: []
},
{
  path: "staff-management/:staffId",
  component: StaffFormComponent,
  canActivate: [permissionGuard(StaffPermission.ManageStaff)],
  data: { animation: "StaffFormView" },
  children: []
},
{
  path: "location-management",
  component: LocationManagementComponent,
  canActivate: [permissionGuard(StaffPermission.ManageLocations)],
  data: { animation: "LocationManagement" },
  children: []
},
{
  path: "location-management/create",
  component: LocationFormComponent,
  canActivate: [permissionGuard(StaffPermission.ManageLocations)],
  data: { animation: "LocationFormCreate" },
  children: []
},
{
  path: "location-management/:locationId/edit",
  component: LocationFormComponent,
  canActivate: [permissionGuard(StaffPermission.ManageLocations)],
  data: { animation: "LocationFormEdit" },
  children: []
},
{
  path: 'program/:id',
  loadComponent: () => import('./program/program').then(m => m.ProgramComponent),
  children: [],
},

{path: "date-selection",
component:DateSelectionComponent,
data:{animation:'DateSelection'},
children:[
]
},
{path: "success-meal-transport",
component:SuccessMealTransportComponent,
children:[
]
},
{path: "meal-preferance",
component:MealPreferanceComponent,
children:[
]
},
{path: "apply-future-dates",
component:ApplyFutureDatesComponent,
data:{animation:'ApplyFutureDates'},
children:[
]
},
{path: "scheduled-confirmed",
component:ScheduledConfirmedComponent,
children:[
]
},
{path: "activity-screen",
component:ActivityScreenComponent,
children:[
]
},
{path: "upcoming-events",
component:UpcomingEventsComponent,
children:[
]
},
{path: "event-details",
component:EventDetailsComponent,
data:{animation:'EventDetails'},
children:[
]
},
{path: "success",
component:SuccessComponent,
data:{animation:'Success'},
children:[
]
},
{path: "error",
component:ErrorFallbackComponent,
data:{animation:'Error'},
children:[
]
},
]